export const slotOKStatus: {
  [key: number]: string;
} = {
  0: 'Appuntamento valido',
  1: 'Appuntamento non valido',
  2: 'Appuntamento valido (forzato manualmente)',
};
